import { ExclamationMarkInOctagon } from '@/components/Icons/ExclamationMarkInOctagon';
import { Popover, PopoverContent, PopoverTrigger } from '@music-vine/cadence/ui';
import { useOverduePayment } from '@/hooks/billing/useOverduePayment';
import { formatOverdueDate, parseOverdueDate } from '@/utils/overdue-payment';
import { Popover as PopoverPrimitive } from 'radix-ui';
import { useEffect, useMemo, useState } from 'react';
import { UpdatePaymentButton } from '@/components/UpdatePaymentButton';
export const UnprotectedChannelsNotice = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [delayedShowPopover, setDelayedShowPopover] = useState(false);
  const {
    overduePayment,
    showPopover
  } = useOverduePayment();
  const description = useMemo(() => {
    const {
      id: overduePaymentId,
      overdueDate
    } = overduePayment ?? {};
    const defaultDescription = 'Your channels may not be protected.';
    if (!(overduePaymentId && overdueDate)) {
      return defaultDescription;
    }
    const parsedDate = parseOverdueDate({
      overdueDate
    });
    if (!parsedDate) {
      return defaultDescription;
    }
    const formattedDate = formatOverdueDate({
      overdueDate: parsedDate
    });
    return <>
        Videos posted after {formattedDate} aren't protected due to a payment
        issue.
      </>;
  }, [overduePayment]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedShowPopover(showPopover);
    }, 10_000);
    return () => {
      clearTimeout(timeout);
    };
  }, [showPopover]);
  return <Popover open={delayedShowPopover} data-sentry-element="Popover" data-sentry-component="UnprotectedChannelsNotice" data-sentry-source-file="UnprotectedChannelsNotice.tsx">
      <PopoverTrigger asChild onClick={() => {
      setDelayedShowPopover(false);
    }} data-sentry-element="PopoverTrigger" data-sentry-source-file="UnprotectedChannelsNotice.tsx">
        <div className="h-full">{children}</div>
      </PopoverTrigger>
      <PopoverContent align="end" alignOffset={12} className="max-w-[24rem] bg-gray-50 px-4 py-1 drop-shadow-[0px_1px_4px_rgba(0,0,0,0.125)] dark:border-none dark:bg-gray-900" side="bottom" data-sentry-element="PopoverContent" data-sentry-source-file="UnprotectedChannelsNotice.tsx">
        <ExclamationMarkInOctagon className="mb-1" data-sentry-element="ExclamationMarkInOctagon" data-sentry-source-file="UnprotectedChannelsNotice.tsx" /> {description}{' '}
        <UpdatePaymentButton className="font-semibold text-gray-950 underline dark:text-white" data-sentry-element="UpdatePaymentButton" data-sentry-source-file="UnprotectedChannelsNotice.tsx">
          Resolve payment
        </UpdatePaymentButton>
        <PopoverPrimitive.Arrow className="fill-gray-50 dark:fill-text-gray-900" height={10} offset={20} width={20} data-sentry-element="PopoverPrimitive.Arrow" data-sentry-source-file="UnprotectedChannelsNotice.tsx" />
      </PopoverContent>
    </Popover>;
};